import {
  getApiFeedbacksCount,
  getApiFeedbacksId,
  patchApiFeedbacksIdMessagesMessageidRead,
  patchApiFeedbacksIdStatus,
  postApiFeedbacksIdMessages,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const feedbackByIdQuery = createQuery({
  handler: getApiFeedbacksId,
})

export const feedbackCountQuery = createQuery({
  handler: getApiFeedbacksCount,
})

export const feedbackCreate = createMutation({
  handler: postApiFeedbacksIdMessages,
})

export const feedbackMarkAsRead = createMutation({
  handler: patchApiFeedbacksIdMessagesMessageidRead,
})

export const feedbackChangeStatus = createMutation({
  handler: patchApiFeedbacksIdStatus,
})
